/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfDataSourceResultDtoOfAnnouncementDto } from '../../models/platform-api-result-of-data-source-result-dto-of-announcement-dto';
import { PlatformGetAllQueryOfDataSourceResultDtoOfAnnouncementDto } from '../../models/platform-get-all-query-of-data-source-result-dto-of-announcement-dto';

export interface PostNotificationsAnnouncementsQueryDatasource$Params {
      body: PlatformGetAllQueryOfDataSourceResultDtoOfAnnouncementDto
}

export function postNotificationsAnnouncementsQueryDatasource(http: HttpClient, rootUrl: string, params: PostNotificationsAnnouncementsQueryDatasource$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfAnnouncementDto>> {
  const rb = new RequestBuilder(rootUrl, postNotificationsAnnouncementsQueryDatasource.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfAnnouncementDto>;
    })
  );
}

postNotificationsAnnouncementsQueryDatasource.PATH = '/api/notifications/announcements/query/datasource';
